import {Button, Dropdown} from '@/components/atoms'
import PropTypes from 'prop-types'

function CategoryWrapper({categories, selectedCategory, setSelectedCategory}) {
  const handleReset = () => {
    // Reset the selected categories when reset is clicked
    setSelectedCategory([])
  }

  const handleCategoryChange = value => {
    setSelectedCategory(value)
  }

  // Convert the backend data to the dropdown list format
  const dropdownList =
    categories?.length &&
    categories?.map(item => ({
      displayText: item?.category?.en,
      id: item?.categoryId,
      isBadge: false,
    }))
  return (
    <>
      <div className="category-header-wrap mb-6">
        <h1 className="category-header float-left">Select Categories to Include</h1>
        <Button
          handleButton={handleReset}
          uiSchema={{
            className: 'float-right',
            size: 'medium',
            title: 'Reset',
            variant: 'secondary',
            isDark: true,
          }}
        />
      </div>
      <div className="grid grid-cols-4">
        <Dropdown
          isJsonWrap={false}
          childList={dropdownList}
          isDark={true}
          label="Category *"
          placeholder="Select Categories"
          selection="multiple"
          updateValue={handleCategoryChange}
          size="medium"
          value={selectedCategory}
        />
      </div>
    </>
  )
}

CategoryWrapper.propTypes = {
  categories: PropTypes.array,
  selectedCategory: PropTypes.array,
  setSelectedCategory: PropTypes.func,
}

export default CategoryWrapper
